import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useMemo } from 'react';
import { queryClient } from '@/shared/api';


export const QueryProvider = ({ children }: { children: React.ReactNode }) => {
    const client = useMemo(() => queryClient, []);

    return <QueryClientProvider client={client}>
        {children}
        {import.meta.env.DEV && (<ReactQueryDevtools initialIsOpen={false} />)}
    </QueryClientProvider>
}
